import type { RouteRecordRaw } from 'vue-router'
const SharedLayout = () => import('@/app/layouts/SharedLayout.vue')

const LoginPage = () => import('@/modules/auth/pages/LoginPage.vue')
import SignupPage from '@/modules/auth/pages/SignupPage.vue';
import ResetPasswordPage from '@/modules/auth/pages/ResetPasswordPage.vue';
import ChangePassword from '@/modules/auth/pages/ChangePassword.vue';
import SelectContextPage from '@/modules/auth/pages/SelectContextPage.vue';
import JoinAsVendorFormPage from '@/modules/vendor/pages/JoinAsVendorForm.vue';
import { getAppModeFromEnv, isVendorMode } from '@/shared/utils/appMode';
import SignupVendorPage from '@/modules/auth/pages/SignupVendorPage.vue';



// const vendor_components = {
//   'signup': SignupVendorPage
// }

// const customer_hoa_components = {
//   'signup': HomeCustomerHoaPage
// }

// const customer_components = {
//   'signup': HomePage
// }

// function getComponent(componentName: string) {
//   switch (getAppModeFromEnv()) {
//     case 'vendor':
//       return vendor_components[componentName] = vendor_components[componentName] || HomePage;
//     case 'customer_hoa':
//       return customer_hoa_components[componentName] = customer_hoa_components[componentName] || HomePage;
//     case 'customer':
//       return customer_components[componentName] = customer_components[componentName] || HomePage;
//     default:
//       return HomePage;
//   }
// }

export const authRoutes: RouteRecordRaw[] = [
  {
    path: '',
    component: SharedLayout,
    meta: { requiresAuth: false },
    children: [
      {
        path: '/login',
        name: 'login.page',
        component: LoginPage,
        meta: { title: 'Login', requiresAuth: false },
      },
      {
        path: '/signup',
        name: 'signup.page',
        component:  isVendorMode() ? SignupVendorPage : SignupPage,
        meta: { title: 'Sign Up', requiresAuth: false },
      },
      {
        path: '/reset-password',
        name: 'reset-password.page',
        component: ResetPasswordPage,
        meta: { title: 'Reset Password', requiresAuth: false },
      },
      {
        path: '/change-password',
        name: 'change-password.page',
        component: ChangePassword,
        meta: { title: 'Change Password', requiresAuth: true },
      },
      {
        path: '/context-selection',
        name: 'context-selection.page',
        component: SelectContextPage,
        meta: { title: 'Select Context', requiresAuth: false },
      },
      {
        path: '/join-as-vendor',
        name: 'join-as-vendor.form',
        component: JoinAsVendorFormPage,
        meta: { title: 'Join as Vendor', requiresAuth: false },
      },
    ],
  },
]
